var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/modules/_html.js
// module id = 308
// module chunks = 0